import {Component, Input} from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
    selector: 'app-array',
    templateUrl: './array.component.html',
    styleUrls: ['./array.component.scss'],
    standalone: false
})
export class ArrayComponent extends FieldArrayType {

    @Input() addTooltip = 'Add to ';
    getAddTooltip() {
        return this.addTooltip + this.field.props.label;
    }

}
